import { render, staticRenderFns } from "./DeleteItemDialog.vue?vue&type=template&id=770471a8&scoped=true&"
import script from "./DeleteItemDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItemDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeleteItemDialog.vue?vue&type=style&index=1&id=770471a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770471a8",
  null
  
)

export default component.exports